<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="rocket"/>
          {{$t('title')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('active')"></b-tab>
          <b-tab :title="$t('tempLock')"></b-tab>
          <b-tab :title="$t('waitToDelete')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')"></b-form-input>
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('campaign') }}</div>
            <div class="col-lg-2">{{ $t('result') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div v-if="item.client.companyName"><span>{{$t('companyName')}}</span>: <b> {{item.client.companyName}} </b></div>
              <div><span>{{$t('domain')}}: </span><b>{{ item.client.domain }}</b></div>
            </div>
            <div class="col-lg-4">
              <div><span>{{ $t('name') }}</span>: <b>{{ item.name }}</b></div>
              <div v-if="item.updateTime">
                <span>{{ $t('updateTime') }}: </span> <b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
              <div v-if="item.createTime">
                <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
            </div>
            <div class="col-lg-2">
              <div>
                <span v-if="item.scheduledDelTime" class="badge badge-danger">{{ $t('waitToDelete') }}</span>
                <span v-else-if="item.active" class="badge badge-success">{{ $t('active') }}</span>
                <span v-else-if="!item.active" class="badge badge-primary">{{ $t('tempLock') }}</span>
              </div>
              <div class="mt-2">
                <span>{{ $t('numberOfContact') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].total | numFormat }}</b>
                <b v-else>0</b>
              </div>
              <div>
                <span>{{ $t('numberOfFinishedContact') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].done | numFormat }}</b>
                <b v-else>0</b>
              </div>
              <div>
                <span>{{ $t('numberOfReadyToCallContact') }}: </span>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <b v-else-if="contactReport[item._id]">{{ contactReport[item._id].readyToCall | numFormat }}</b>
                <b v-else>0</b>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="text-center">
                <setting :campaign="item"></setting>
                <button v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)" @click="syncIndex(item.client.domain, item._id, item.name)" type="button" class="btn btn-sm btn-warning">
                  <font-awesome-icon icon="sync"/>&nbsp;{{$t('syncIndex')}}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
import Setting from './CampaignInfo.vue'

export default {
  components: {ClientSelect, Setting},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/call-campaign',
      defaultFilterFormModel: {
        status: null,
        keyword: null,
      },
      resultLoading: false,
      contactReport: {},
      afterLoad(){
        this.getResults();
      },
    }
  },
  methods: {
    getResults() {
      this.resultLoading = true;
      let ids = this.items.map(item => {
        return item._id;
      })
      if (ids && ids.length) {
        this.$service.post(this.service + "/contact-count", {ids: ids}).then(response => {
          this.contactReport = {};
          response.data.forEach(item => {
            this.contactReport[item._id] = item;
          });
        }).finally(() => {
          this.resultLoading = false;
        });
      }
    },
    syncIndex(domain, campaign, campaignName) {
      this.$swal({
        title: this.$t('syncIndex'),
        html: this.$t('syncIndexAlert', [campaignName]),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.post(this.service + '/sync-index', {
            domain: domain,
            campaign: campaign
          }).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('success'),
                text: this.$t('syncSuccessful'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('syncFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    }
  },
  i18n: {
    messages: {
      en: {
        title: "Call campaign",
        active: "Active",
        tempLock: "Temporary lock",
        waitToDelete: "Wait to delete",
        campaign: 'Campaign',
        result: 'Result',
        numberOfContact: "Number of contact",
        numberOfFinishedContact: "Number of finished contact",
        numberOfReadyToCallContact: "Number of ready to call contact",
        syncIndex: "Synchronize index",
        syncSuccessful: "Synchronize successful",
        syncFailed: "Synchronize failed",
        syncIndexAlert: "Are you sure you want to sync your <b>{0}</b> campaign index?"
      },
      vi: {
        title: "Chiến dich gọi",
        active: "Đang hoạt động",
        tempLock: "Tạm khoá",
        waitToDelete: "Chờ xoá",
        campaign: 'Chiến dịch',
        result: 'Kết quả',
        numberOfContact: "Số liên hệ",
        numberOfFinishedContact: "Số liên hệ đã hoàn thành",
        numberOfReadyToCallContact: "Số liên hệ sẵn sàng để gọi",
        syncIndex: "Đồng bộ index",
        syncSuccessful: "Đồng bộ thành công",
        syncFailed: "Đồng bộ thất bại",
        syncIndexAlert: "Bạn có chắc muốn đồng bộ index chiến dịch <b>{0}</b> không?"
      }
    }
  },
};
</script>